<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.name}}</span>
        </el-col>
        <el-col :span="8" align="right">
          <el-button v-if="detail.id" type="text" @click="handleCareSms">慰问短信</el-button>
          <el-button v-if="detail.id" type="text" @click="handleAssign()">分配</el-button>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">客户名称</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">联系人角色</div>
          <div class="value">{{detail.businessRole}}</div>
        </div>
        <div class="base-item">
          <div class="title label">部门</div>
          <div class="value">{{detail.apartment}}</div>
        </div>
        <div class="base-item">
          <div class="title label">职务</div>
          <div class="value">{{detail.position}}</div>
        </div>
        <div class="base-item">
          <div class="title label">手机号</div>
          <el-button type="text" title="点击获取完整手机号" v-if="detail.needHideMobile && !queryMobileFlag" @click="queryMobile">{{desensitizeMobile(detail.mobile)}}</el-button>
          <div class="value" v-else>{{detail.mobile}}</div>
        </div>
        <div class="base-item">
          <div class="title label">最新跟进时间</div>
          <div class="value">{{detail.lastFollowInfo ? detail.lastFollowInfo.createTime : ""}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进计划" name="followPlan">
              <el-tabs v-model="followPlanActiveName" :stretch="true">
                <el-tab-pane label="跟进记录" name="follow">
                  <FollowAdd :targetId="detail.id" targetType="contact" @success="handleAfterFollowAdd"></FollowAdd>
                  <div style="height: 473px">
                    <FollowList :targetId="detail.id" targetType="contact" ref="followListRef"></FollowList>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工作计划" name="workPlan">
                  <WorkPlan ref="workPlanRef" :targetId="detail.id" targetType="contact" :managerId="detail.manager ? detail.manager.managerId : null" @success="handleAfterWorkPlanAdd"></WorkPlan>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel" :disabled="!detail.id">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="100px" :hide-required-asterisk="!editModel">
                <el-row :gutter="20" align="left">
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="联系人:" prop="name">
                      <el-input v-if="editModel" v-model="updateData.name" :maxlength="32" placeholder="请输入联系人姓名" clearable/>
                      <span v-else class="value">{{detail.name}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户名称:" prop="customerId">
                      <customer-select v-if="editModel && customerOriginalIsEmpty" ref="customerSelectRef" :auth-check="true" :form-param="updateData"></customer-select>
                      <el-button v-else type="text" @click="toCustomerDetail">{{detail.customerName}}</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="部门:" prop="apartment">
                      <el-input v-if="editModel" v-model="updateData.apartment" :maxlength="32" placeholder="请输入部门" clearable/>
                      <span v-else class="value">{{detail.apartment}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="职务:" prop="position">
                      <el-input v-if="editModel" v-model="updateData.position" :maxlength="32" placeholder="请输入职务" clearable/>
                      <span v-else class="value">{{detail.position}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="手机号:" prop="mobile">
                      <el-input v-if="editModel" v-model="updateData.mobile" placeholder="请输入手机号" clearable/>
                      <span v-if="editModel" slot="error" slot-scope="scope">
                        <span v-if="scope.error.indexOf('#error#') > -1" class="el-form-item__error">
                          已被该客户下联系人
                          <el-link
                            style="font-size: 12px; vertical-align: top;"
                            type="primary"
                            :underline="false"
                            @click="toDetailBlank(scope.error.split('#error#')[0])">
                            {{ scope.error.split('#error#')[1] }}
                          </el-link>
                          使用，请重新输入
                        </span>
                        <span v-else class="el-form-item__error">{{scope.error}}</span>
                      </span>
                      <el-button type="text" title="点击获取完整手机号" v-if="!editModel && !queryMobileFlag && detail.needHideMobile" @click="queryMobile">{{desensitizeMobile(detail.mobile)}}</el-button>
                      <div class="value" v-else-if="!editModel && (queryMobileFlag || !detail.needHideMobile)">{{detail.mobile}}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="微信号:" prop="wechat">
                      <el-input v-if="editModel" v-model="updateData.wechat" :maxlength="32" placeholder="请输入微信号" clearable/>
                      <span v-else class="value">{{detail.wechat}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="性别:" prop="sex">
                      <el-select v-if="editModel" v-model="updateData.sex" placeholder="请选择性别" clearable style="width:100%">
                        <el-option v-for="dict in sexOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                      </el-select>
                      <span v-else class="value">{{detail.sexDesc}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="立场:" prop="standScore">
                      <el-input v-if="editModel" v-model="updateData.standScore" :maxlength="32" placeholder="请输入立场" clearable/>
                      <span v-else class="value">{{detail.standScore}}</span>
                      <el-popover
                        placement="top-start"
                        title="立场评分标准"
                        width="500"
                        trigger="hover">
                        <span>备注：红色字体为市场主要手段<br>
                            内线（+3）<br>
                            传递客户内部信息（决策流程、决策成员组及其关注点、预算等）<br>
                            传递竞争对手动态情况（小组成员、关键行动、方案及报价等）并对我方敏感信息进行保密；<br>
                            给出项目推进的建议<span style="color:red;">（签约的关键推动人）</span><br>
                            帮助我方创造销售机会，配合我们执行销售计划<br>
                            支持（+2）<br>
                            愿意支持双方合作<br>
                            <span style="color:red;">愿意参与活动，并作为分享嘉宾发言（包括沙龙/发布会/论坛/直播课程等）</span><br>
                            主动传递我们的价值<br>
                            <span style="color:red;">1、接受瑞洁特的专访且稿件在瑞洁特自媒体或环保水圈等任一渠道发表</span><br>
                            <span style="color:red;">2、作为关键对接人配合瑞洁特进行案例包装</span><br>
                            <span style="color:red;">3、接受瑞洁特/环保水圈参观交流接待（活动的客户方接待人)</span>
                        </span>
                        <el-button type="text" slot="reference">立场评分说明</el-button>
                      </el-popover>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="出生年月:" prop="birthday">
                      <el-date-picker v-if="editModel" v-model="updateData.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                      <span v-else class="value">{{detail.birthday}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="电子邮箱:" prop="email">
                      <el-input v-if="editModel" v-model="updateData.email" :maxlength="64" placeholder="请输入电子邮箱" clearable/>
                      <span v-else class="value">{{detail.email}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="所在区域:" prop="area">
                      <el-cascader v-if="editModel" v-model="updateData.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
                      <span v-else class="value">{{detail.areaName}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="详细地址:" prop="address">
                      <el-input v-if="editModel" v-model="updateData.address" :maxlength="64" placeholder="请输入详细地址" clearable/>
                      <span v-else class="value">{{detail.address}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建人:">
                      <span class="value">{{detail.createUserName}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建时间:">
                      <span class="value">{{detail.createTime}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="备注:" prop="remark">
                      <el-input
                        v-if="editModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateData.remark"
                        placeholder="请输入备注"
                        clearable/>
                      <span v-else class="value">{{detail.remark}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="`任职履历(${resumeCount})`" name="resume">
              <ResumeList ref="resumeListRef" :contactId="detail.id" @success="refreshDetailAndLog" @after-query="handleAfterResumeQuery"/>
            </el-tab-pane>
            <el-tab-pane :label="'商机(' + businessCount + ')'" name="business">
              <BusinessList ref="businessListRef" :contactId="detail.id" :param-data="detail" height="630" @after-query="handleAfterBusinessQuery"></BusinessList>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.manager ? detail.manager.managerAvatar : ''" :name="detail.manager ? detail.manager.managerName : ''"/>
            <div class="name"><span class="value">{{detail.manager ? detail.manager.managerName : ""}}</span></div>
          </div>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="contact"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
    <ContactCareSmsDialog ref="contactCareSmsDialogRef"></ContactCareSmsDialog>
  </div>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import WorkPlan from "@/views/crm/workPlan/workPlan";
import OperateLogList from "@/views/crm/components/operateLogList";
import AssignDialog from "@/views/crm/components/assignDialog";
import BusinessList from "@/views/crm/business/businessList";
import ResumeList from "@/views/crm/contact/resumeList";
import {isPhone} from "@/utils/validate";
import {emailValid} from "@/utils/validator";
import {updateContact, queryContactDetail, queryContactByMobileAndCustomer, queryMobile} from "@/api/crm/contact";
import UserAvatar from '@/views/system/user/userAvatar'
import customerSelect from "@/views/crm/components/customerSelect";
import {desensitizeMobile, transferCascaderOptionsForProvince} from '@/utils/index'
import {mapState} from "vuex";
import {listAllLevelArea} from "@/api/crm/area";
import ContactCareSmsDialog from "@/views/crm/contact/contactCareSmsDialog";

export default {
  name: "ContactDetail",
  data() {
    return {
      desensitizeMobile,
      // 遮罩层
      loading: true,
      detail: {},
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      editModel: false,
      sexOptions: [],
      businessCount: 0,
      resumeCount: 0,
      areaOptions: [],
      updateData: {
        id: null,
        name: null,
        customerId: null,
        apartment: null,
        position: null,
        mobile: null,
        wechat: null,
        sex: null,
        standScore: null,
        birthday: null,
        email: null,
        area: [],
        address: null,
        remark: null
      },
      customerOriginalIsEmpty: false,
      queryMobileFlag: false,
      updateRules: {
        name: [
          {required: true, message: '请输入联系人姓名', trigger: 'change'}
        ],
        mobile: [
          { validator: this.checkMobile, trigger: "change" }
        ],
        managerId: [
          {required: true, type: 'number', message: '请选择负责人', trigger: 'change'}
        ],
        email: [
          {validator: emailValid, trigger: 'change'}
        ]
      },
    };
  },
  components: {
    FollowList,
    FollowAdd,
    WorkPlan,
    OperateLogList,
    AssignDialog,
    BusinessList,
    UserAvatar,
    customerSelect,
    ResumeList,
    ContactCareSmsDialog
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的联系人");
    }
    this.getDicts("sys_user_sex").then(response => {
      this.sexOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.name === 'business') {
        this.$refs.businessListRef.queryList()
      }
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryContactDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
          this.customerOriginalIsEmpty = this.detail.customerId == null
        } else {
          this.msgError("查询不到此联系人");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    checkMobile (rule, value, callback) {
      // 非必填
      if (!value || value === this.detail.mobile) {
        callback()
      } else if (isPhone(value)) {
        queryContactByMobileAndCustomer(
          {
            mobile: value,
            customerId: this.detail.customerId
          }
        ).then( response => {
          if (response.data && response.data.id) {
            callback(new Error(response.data.id + '#error#' + response.data.name))
          } else {
            callback()
          }
        }).catch(error => {
          callback()
        })
      } else {
        callback(new Error('格式不正确'))
      }
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleAfterBusinessQuery (businessList) {
      this.businessCount = businessList.length;
    },
    handleAfterResumeQuery (count) {
      this.resumeCount = count;
    },
    handleEdit () {
      this.updateData.id = this.detail.id;
      this.updateData.customerId = this.detail.customerId;
      this.updateData.name = this.detail.name;
      this.updateData.apartment = this.detail.apartment;
      this.updateData.position = this.detail.position;
      this.updateData.mobile = this.detail.mobile;
      this.updateData.wechat = this.detail.wechat;
      this.updateData.sex = this.detail.sex;
      this.updateData.standScore = this.detail.standScore;
      this.updateData.birthday = this.detail.birthday;
      this.updateData.email = this.detail.email;
      const {area, address, provinceCode, cityCode, regionCode} = this.detail
      this.updateData.area = area;
      let areaTemp = []
      provinceCode && areaTemp.push(provinceCode)
      cityCode && areaTemp.push(cityCode)
      regionCode && areaTemp.push(regionCode)
      this.updateData.area = areaTemp
      this.updateData.address = address
      this.updateData.remark = this.detail.remark;
      this.editModel = true
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.updateData.provinceCode = this.updateData.area && this.updateData.area.length > 0 ? this.updateData.area[0] : null
          this.updateData.cityCode = this.updateData.area && this.updateData.area.length > 1 ? this.updateData.area[1] : null
          this.updateData.regionCode = this.updateData.area && this.updateData.area.length > 2 ? this.updateData.area[2] : null
          updateContact(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).finally(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    toDetailBlank(id) {
      this.$router.push("/crm/contact/detail/" + id);
    },
    /** 详细按钮操作 */
    toCustomerDetail() {
      this.$router.push("/crm/customer/detail/" + this.detail.customerId);
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("contact", this.detail.id)
    },
    handleCareSms() {
      this.$refs.contactCareSmsDialogRef.open(this.detail)
    },
    handleAfterWorkPlanAdd () {
      this.refreshOperateLogList();
      this.$refs["followListRef"].refresh()
    },
    queryMobile(){
      const loading = this.$loading({lock: true, text: '查询中', spinner: 'el-icon-loading'});
      queryMobile({
        id: this.detail.id
      }).then(response => {
        if (response.data) {
          this.queryMobileFlag = true
        }
      }).finally(error => {
        loading.close()
      })
    }
  }
};
</script>
